import api from '../services/api'
import { REGISTER_DEVICE_SUCCESS, DEVICE_UNREGISTER } from './device'
import { RESET } from '../redux/game'
// Actions
const REGISTER_TEAM_START = 'ascension/register-team/fetching'
const REGISTER_TEAM_SUCCESS = 'ascension/register-team/success'
const REGISTER_TEAM_ERROR = 'ascension/register-team/error'
export const TEAM_CHANGED = 'ascension/team/change'

// Reducer
const initialState = {
  id: null,
  registered: false,
  registering: false,
  error: null,
  name: null,
  strategy: null
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case REGISTER_DEVICE_SUCCESS: {
      return {
        ...state,
        id: action.data.teamId
      }
    }
    case DEVICE_UNREGISTER: {
      return {
        ...state,
        registered: false,
        name: null,
        strategy: null
      }
    }
    case REGISTER_TEAM_START: {
      return {
        ...state,
        registering: true,
        registered: false,
        error: null
      }
    }
    case REGISTER_TEAM_SUCCESS: {
      return {
        ...state,
        registering: false,
        registered: true,
        name: action.data.name,
        strategy: action.data.strategy,
        error: null
      }
    }
    case REGISTER_TEAM_ERROR: {
      return {
        ...state,
        registered: false,
        registering: false,
        error: action.data
      }
    }
    case TEAM_CHANGED: {
      return {
        ...state,
        ...action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function registerTeamStart () {
  return {
    type: REGISTER_TEAM_START
  }
}

export function registerTeamSuccess (data) {
  return {
    type: REGISTER_TEAM_SUCCESS,
    data
  }
}

export function registerTeamError (error) {
  return {
    type: REGISTER_TEAM_ERROR,
    data: error
  }
}

export function teamChange (data) {
  return {
    type: TEAM_CHANGED,
    data
  }
}

export function registerTeam (teamId, name, strategy) {
  return async (dispatch) => {
    dispatch(registerTeamStart())

    try {
      const response = await api.registerTeam(teamId, name, strategy)
      dispatch(registerTeamSuccess(response))
    } catch (e) {
      dispatch(registerTeamError(e))
    }
  }
}
